import "./projectType.css";

import {
  ProjectTypeBiocharIcon,
  ProjectTypeBiodiversityIcon,
  ProjectTypeBioEnergyIcon,
  ProjectTypeConstructedWetlandIcon,
  ProjectTypeEnhancedWeatheringIcon,
  ProjectTypeForestryAndWoodlandCreationIcon,
  ProjectTypeHedgerowAndAgroforestryIcon,
  ProjectTypeLivestockFeedIcon,
  ProjectTypeNaturalFloodManagementIcon,
  ProjectTypeNutrientNeutralityIcon,
  ProjectTypePeatlandIcon,
  ProjectTypeRewildingIcon,
  ProjectTypeSaltmarshRestorationIcon,
  ProjectTypeSeagrassRestorationIcon,
  ProjectTypeSoilCarbonIcon,
  WorkflowBlueIcon,
} from "../../assets";

export const getIconFromProjectType = (projectTypeUuid: string, size?: number): JSX.Element => {
  switch (projectTypeUuid) {
    case "f841838b-8ea4-4854-a26d-aeeb6b5284c7":
      return (
        <ProjectTypeForestryAndWoodlandCreationIcon className="ProjectTypeForestGreen" width={size} height={size} />
      );
    case "81fe62ab-32f1-4019-9e74-40f76d8a1fb5":
      return <ProjectTypeHedgerowAndAgroforestryIcon className="ProjectTypeForestGreen" width={size} height={size} />;
    case "fcd54321-6ff6-48fa-b42d-fd485205fea3":
      return <ProjectTypeRewildingIcon className="ProjectTypeForestGreen" width={size} height={size} />;
    case "9009eefc-fe4d-4c13-8bad-b99123f4b0aa":
      return <ProjectTypeBiodiversityIcon width={size} height={size} />;
    case "7a173441-af80-4b2d-8043-f995c6ec8059":
      return <ProjectTypePeatlandIcon className="ProjectTypeDarkCoral" width={size} height={size} />;
    case "f4b67ac1-dcec-4e81-adab-a6fa6a96079f":
      return <ProjectTypeSoilCarbonIcon className="ProjectTypeDarkCoral" width={size} height={size} />;
    case "b2962df1-f83b-4e99-885d-6eb008211b5f":
      return <ProjectTypeBioEnergyIcon className="ProjectTypeDarkCoral" width={size} height={size} />;
    case "3d78fa92-0769-4400-8138-3f2a5bf37264":
      return <ProjectTypeSeagrassRestorationIcon className="ProjectTypeDarkCyan" width={size} height={size} />;
    case "c7686b9b-3209-445a-88ce-03845168b577":
      return <ProjectTypeConstructedWetlandIcon className="ProjectTypeDarkCyan" width={size} height={size} />;
    case "ee020ebb-f1f0-49d6-84d6-84c0e305aadf":
      return <ProjectTypeSaltmarshRestorationIcon className="ProjectTypeDarkCyan" width={size} height={size} />;
    case "c7b08078-97c1-48d2-be47-9f2f5f1a9d85":
      return <ProjectTypeNaturalFloodManagementIcon className="ProjectTypeDarkCyan" width={size} height={size} />;
    case "77a61b62-429e-486a-8508-a023a876c90c":
      return <ProjectTypeEnhancedWeatheringIcon className="ProjectTypeGrey" width={size} height={size} />;
    case "385b5d60-f97a-4652-b63e-cc6af292d1f2":
      return <ProjectTypeBiocharIcon className="ProjectTypeGrey" width={size} height={size} />;
    case "5ddd0af4-1c0b-410c-9df4-e6f76ad37cfa":
      return <ProjectTypeLivestockFeedIcon className="ProjectTypeGrey" width={size} height={size} />;
    case "56c274e9-2f78-477c-b6da-bc92d07fb2de":
      return <ProjectTypeNutrientNeutralityIcon width={size} height={size} />;
    default:
      return <WorkflowBlueIcon width={size} height={size} />;
  }
};
